import styled from "styled-components";
import { Grid } from "@material-ui/core";

export const FormWithCenteredContent = styled.form`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 15px;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
`;

export const AuthProvidersGridRoot = styled(Grid)`
  && {
    padding-top: 20px;
    width: 100%;
    align-items: center;
  }
`;

export const AuthProvidersGridTitle = styled(Grid)`
  && {
    font-weight: 500;
    padding-bottom: 8px;
    text-align: center;
  }
`;

export const AuthProviderImg = styled.img`
  max-height: 20px;
  max-width: 20px;
`;

export const AuthProviderName = styled.div`
  font-size: 0.9rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
`;

export const AuthProvidersGridContent = styled.div`
  && {
    display: flex;
    min-width: min-content;
    align-items: center;
    border: 1px solid #d0d0d0;
    border-radius: 4px;
    margin: 6px 4px 6px 4px;
    width: calc(50% - 20px);
    padding: 4px;
    cursor: pointer;
    justify-content: center;
    opacity: 1;
    &:hover {
      opacity: 0.5;
    }
  }
`;

export const AuthProvidersGrid = styled.div`
  && {
    margin: -6px -6px;
    text-align: -webkit-center;
  }
`;
